export function prepareCustomerAvatar(file) {
  if (!file || !file.type.startsWith("image/")) return Promise.resolve(null);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      image.onload = () => {
        const scale = Math.min(1, 180 / Math.max(image.width, image.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(image.width * scale));
        canvas.height = Math.max(1, Math.round(image.height * scale));
        canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.68));
      };
      image.onerror = reject;
      image.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function customerAvatarKey(restaurantId, phoneValue) {
  return `customer_avatar_${restaurantId}_${String(phoneValue || "").replace(/\D/g, "")}`;
}

export function getCachedCustomerAvatar(restaurantId, phoneValue, legacyPhone = "") {
  try {
    return localStorage.getItem(customerAvatarKey(restaurantId, phoneValue))
      || (legacyPhone && localStorage.getItem(customerAvatarKey(restaurantId, legacyPhone)))
      || localStorage.getItem(`customer_avatar_${restaurantId}`)
      || null;
  } catch {
    return null;
  }
}

export function hydrateCustomerAvatar(profile, restaurantId, phoneValue, legacyPhone = "") {
  return profile
    ? { ...profile, avatar_url: profile.avatar_url || getCachedCustomerAvatar(restaurantId, phoneValue, legacyPhone) }
    : profile;
}
